import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Link, StoryElement, WithHostUrl, SocialShare } from "@quintype/components";
import { WebEngage, GA, PGAD, DeepBI } from "../../../integrations";
import Navbar from "../../atoms/secondary-menu";
import { ZodiacIcon } from "../../atoms/icon";
import { PAGE_TYPE } from "../../../constants";
import styles from "./styles.m.css";
import { VikatanSticky, PGAdwithAd } from "../../rows/ad-free";
import Media from "react-media";
import Tags from "../story/story-templates/shared/tags";
import AuthorDetail from "../story/story-templates/shared/author-detail";
import { getMonthString, humanizeDate } from "../../utils/time-format";
import { MgidUnderArticleAd } from "../../atoms/mgid-2025/underArticle";
import { SocialShareTemplate } from "../story/story-templates/shared/social-share";

const ALMANAC_HEADLINE = "பஞ்சாங்கம்";

export class RasipalanLandingPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedZodiac: "aries",
      isDropdownOpen: false
    };
    this.selectZodiac = this.selectZodiac.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  selectZodiac(type) {
    this.setState({ selectedZodiac: type, isDropdownOpen: false });
  }

  toggleDropdown() {
    this.setState({ isDropdownOpen: !this.state.isDropdownOpen });
  }

  componentDidMount() {
    WebEngage.registerPageView();
    GA.registerPageView(PAGE_TYPE.RASIPALAN_PAGE, { story: get(this.props, ["data", "story"], {}) });
    PGAD.loadScript();
    DeepBI.registerPageView({ story: get(this.props, ["data", "story"], {}) });
  }

  render() {
    const data = get(this.props, ["data"], null);
    const dateInTamil = getDateInTamil(get(data, ["story", "last-published-at"], ""));
    const headline = get(data, ["story", "headline"], "Today's Rasi Palan");
    // const subheadline = get(data, ["story", "subheadline"], "");
    const story = get(data, ["story"], {});
    const subMenu = get(data, ["menuData"], {});
    const almanac = get(data, ["almanac"], []) || [];
    const zodiacSlug = get(data, ["zodiacSlug"], "mesha");
    const rasipalanSlug = get(data, ["rasipalanSlug"], "rasipalan");
    const getMonthStr = getMonthString(get(data, ["story", "last-published-at"]));

    const today = new Date();
    const currentDay = today.getDay();
    const diff = today.getDate() - currentDay + (currentDay === 0 ? -6 : 1); // Adjust for Sunday

    const startOfWeek = new Date(today.setDate(diff));
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);

    // Function to format the date as DD-MM-YYYY
    function formatDate(date) {
      const day = date.getDate();
      const month = date.getMonth() + 1; // Months are zero-based
      const year = date.getFullYear();

      return `${day < 10 ? "0" + day : day}-${month < 10 ? "0" + month : month}-${year}`;
    }

    const formattedStartOfWeek = formatDate(startOfWeek);
    const formattedEndOfWeek = formatDate(endOfWeek);

    const almanacTRs = almanac.map(({ key, displayName, value }) => (
      <tr key={key} className={styles.almanac__entity}>
        <th>{displayName}</th>
        <td>{value}</td>
      </tr>
    ));

    const config = get(this.props, ["config"], {});

    const renderSocialMedia = (className = "", stickyShare = false, rasipalanShare = true) => (
      <SocialShare
        className={className}
        template={SocialShareTemplate}
        story={story}
        fullUrl={story.url}
        title={story.headline}
        handleClickView={this.handleClickView}
        stickyShare={stickyShare}
        rasipalanShare={rasipalanShare}
        hashtags={
          story.tags &&
          story.tags
            .filter(tag => tag !== null)
            .map(tag => tag.name)
            .toString()
        }
        storyId={story.id}
      />
    );

    const customHeadLine =
      rasipalanSlug === "rasipalan"
        ? `இன்றைய ராசிபலன் (Rasi Palan) - ${dateInTamil.month} ${dateInTamil.date}, ${dateInTamil.year} ${
            dateInTamil.week
          }`
        : rasipalanSlug === "weekly-rasipalan"
          ? `வார ராசிபலன் (Weekly Rasi Palan in Tamil) - ${formattedStartOfWeek} முதல் ${formattedEndOfWeek} வரை`
          : `${getMonthStr} மாத ராசிபலன் - Monthly Horoscope in Tamil`;

    return (
      <div className={`${styles["page"]} main-page`}>
        <div />
        <div>
          {subMenu ? (
            <Navbar
              menuGroup={subMenu}
              slug={"spiritual"}
              className={`${styles["submenu"]} ${"container-full-mobile"}`}
              communityColor={subMenu.bgColor}
            />
          ) : null}
          <div className="container">
            <ul className={`${styles.breadcrumbs}`} itemScope itemType="http://schema.org/BreadcrumbList">
              <li
                className={styles.breadcrumb}
                itemProp="itemListElement"
                itemScope
                itemType="http://schema.org/ListItem"
              >
                <WithHostUrl>
                  {({ primaryHostUrl }) => (
                    <Link aria-label={config["publisher-name"]} href={primaryHostUrl} itemprop="item">
                      <span itemProp="name">{config["publisher-name"]}</span>
                    </Link>
                  )}
                </WithHostUrl>
                <meta itemProp="position" content={1} />
              </li>
              <li
                className={styles.breadcrumb}
                itemProp="itemListElement"
                itemScope
                itemType="http://schema.org/ListItem"
              >
                <Link
                  aria-label={`${"Navigate to "} ${rasipalanSlug}`}
                  href={`/horoscope/${rasipalanSlug}`}
                  itemprop="item"
                >
                  <span itemProp="name">{rasipalanSlug.replace(/-/g, " ")}</span>
                </Link>
                <meta itemProp="position" content={2} />
              </li>
            </ul>

            <div className={styles.rasipalan_header}>
              <h1 className={styles.headline}>
                {customHeadLine}
                <div>{renderSocialMedia()}</div>
              </h1>
              <div className={styles.vikatan_playbanner}>
                <a
                  href="https://www.vikatan.com/vikatan-play/daily-rasi-palan?pfrom=rasipalan-page"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://media.vikatan.com/vikatan/2025-07-01/19h4gmy5/Listenaudiorasipalan.png"
                    // className="hidden-mobile"
                  />
                </a>
              </div>
            </div>

            <div className={styles["rasipalan__base"]}>
              <div>
                <div>
                  {rasipalanSlug === "monthly-rasipalan" && (
                    <div>
                      <p className={styles["rasi-title"]}>வணக்கம் வாசகர்களே!</p>
                      <p>
                        மேஷம் முதல் மீனம் வரை... 12 ராசிகளுக்குமான தமிழ் மாத ராசி பலன்களை (Monthly Rasi Palan)
                        விகடனுக்காக இங்கே கணித்து தந்திருக்கிறார் ஜோதிடஶ்ரீ ஜோதிடஶ்ரீ முருகப்ரியன். உத்தியோகத்தில்
                        இருப்பவர்கள், தொழில்துறையினர், பெண்கள், பொது பலன் என அனைத்து தரப்பினருக்குமான துல்லிய பலன்கள்,
                        ராசிகளுக்கான சந்திராஷ்டம நாள்கள், அதிர்ஷ்ட நாள்கள், பாராயணத்துக்குரிய மந்திரங்கள்,
                        அவரவர்களுக்கான பிரத்யேக பரிகாரங்கள் என முழுமையான வழிகாட்டி இது.
                      </p>
                    </div>
                  )}
                  {rasipalanSlug === "weekly-rasipalan" && (
                    <div>
                      <p className={styles["rasi-title"]}>வணக்கம் வாசகர்களே!</p>
                      <p>
                        திங்கள் முதல் வெள்ளி வரை... இந்த வாரம் உங்கள் ராசிக்கு எப்படி இருக்கும்? துல்லியமான ஜோதிட
                        வழிகாட்டல்களுடன் இங்கே விடையளிக்கிறார் ஜோதிடஶ்ரீ முருகப்ரியன்.
                      </p>
                    </div>
                  )}
                  {rasipalanSlug === "rasipalan" && (
                    <div>
                      <p className={styles["rasi-title"]}>வணக்கம் வாசகர்களே!</p>
                      <p>
                        விகடன் வாசகர்களுக்கான இன்றைய ராசிபலன்களை (Today Rasipalan) துல்லியமாக இங்கே கணித்து
                        தந்திருக்கிறார் ஜோதிடஶ்ரீ முருகப்ரியன். மேஷம் முதல் மீனம் வரையிலான 12 ராசிகளுக்குமான தின பலன்கள்
                        மட்டுமன்றி, 27 நட்சத்திரங்களுக்கும் அந்தந்த ராசிகளின் அடிப்படையில் பலன்கள் தொகுக்கப்பட்டுள்ளன.
                      </p>
                    </div>
                  )}{" "}
                  <div className={styles["updated-socialshare"]}>
                    <div className={`${styles.published_date} ${styles.rasipalan__summary}`}>
                      {story["last-published-at"] && (
                        <span className={styles["updated"]}>
                          Last Updated:
                          <time className={styles.time} dateTime={new Date(story["last-published-at"]).toISOString()}>
                            {humanizeDate(
                              story["last-published-at"],
                              this.state.showRelativeTime ? "relative" : "absolute"
                            )}
                          </time>
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <Media query="(max-width:767px)">
                  <PGAdwithAd
                    adId={`Vikatan2023_Mobile_AP_ATF_336x280`}
                    adSize={[[336, 280], [300, 250]]}
                    minHeight={280}
                    adDivId="div-ad-desk-3849069-877415-2"
                    class="ad_300_250"
                    story={story}
                  />
                </Media>
              </div>
              <div className={`${styles.rasipalan__row}`}>
                <div className={styles.rasipalan__sidebar}>
                  <SideBar
                    zodiacs={data.zodiacs}
                    selectedZodiac={zodiacSlug}
                    rasipalanSlug={rasipalanSlug}
                    className={!this.state.isDropdownOpen ? styles.sidebar__collapse : styles.sidebar__expand}
                    config={config}
                  />
                  {rasipalanSlug === "monthly-rasipalan" && (
                    <div>
                      <p>
                        மேலே இருக்கும் ராசிகளை க்ளிக் செய்து உங்கள் ராசிக்கான தமிழ் மாத ராசி பலன்களைத்
                        தெரிந்துகொள்ளுங்கள். ஒவ்வொரு தமிழ் மாத தொடக்கத்திலும் அம்மாதத்திற்கான பலன்கள் இங்கே அப்டேட்
                        ஆகும்.
                      </p>
                    </div>
                  )}

                  {rasipalanSlug === "weekly-rasipalan" && (
                    <div>
                      <p>
                        மேஷம் முதல் மீனம் வரை 12 ராசிகளுக்குமான துல்லியமான இந்த வார ராசிபலன்கள் (Tamil Weekly Rasi
                        Palan), பெண்கள், வியாபாரிகள், ஊழியர்கள் என பல தரப்பினருக்குமான சிறப்பு பலன்கள், 12
                        ராசிகளுக்குமான அதிர்ஷ்ட நாள்கள், அதிர்ஷ்ட எண்கள், வழிபட வேண்டிய தெய்வம், சிக்கல் இருப்பவர்கள்
                        பாராயணம் செய்ய வேண்டிய மந்திரங்கள் என விரிவான வார ராசி பலன்கள் உள்ளே...
                      </p>
                      <p>
                        மேலே உள்ள ராசிகளை க்ளிக் செய்து உங்களுக்கான பலன்களைத் தெரிந்துகொள்ளுங்கள். வாரந்தோறும் பலன்களை
                        மிஸ் செய்யாமல் இருக்க இந்தப் பக்கத்தில் தொடர்ந்து இணைந்திருங்கள்!
                      </p>
                    </div>
                  )}

                  {rasipalanSlug === "rasipalan" && (
                    <div>
                      <p>
                        மேலே இருக்கும் ராசிகளைக் க்ளிக் செய்து உங்கள் ராசிக்கான இன்றைய பலன்களைக் காணலாம். மாத பலன்
                        மற்றும் வார பலன்களையும் உள்ளே சென்று ராசி வாரியாகப் படிக்கலாம். தினந்தோறும் உங்கள் ராசிக்கான
                        துல்லிய பலன்களைப் பெற தொடர்ந்து இந்த பக்கத்துடன் இணைந்திருங்கள். இந்த நாள் இனிய நாளாகட்டும்!
                      </p>
                    </div>
                  )}
                </div>

                <aside className={styles.rasipalan__aside}>
                  <Media query="(min-width:768px)">
                    <PGAdwithAd
                      adId={`Vikatan2023_Desktop_AP_RightATF_336x280`}
                      adSize={[[336, 280], [300, 250]]}
                      minHeight={280}
                      adDivId="div-ad-desk-3849069-345-2"
                      class="ad_300_250"
                      story={story}
                    />
                  </Media>
                  <Media query="(max-width:768px)">
                    <PGAdwithAd
                      adId={`Vikatan2023_Mobile_AP_MID2_336x280`}
                      adSize={[[336, 280], [300, 250]]}
                      minHeight={280}
                      adDivId="div-ad-desk-3849069-4456-2"
                      class="ad_300_250"
                      story={story}
                    />
                  </Media>
                  {almanacTRs.length > 0 &&
                    headline === "இன்றைய ராசிபலன்" && (
                      <div className={styles.rasipalan_almanac}>
                        <h2 className={styles.almanac__headline}>{ALMANAC_HEADLINE}</h2>
                        <table className={styles.almanac__table}>
                          <tbody>{almanacTRs}</tbody>
                        </table>
                      </div>
                    )}
                  <PGAdwithAd
                    adId={`Vikatan2023_Desktop_AP_MID2_336x280`}
                    adSize={[[336, 280], [300, 250]]}
                    minHeight={280}
                    adDivId="div-ad-desk-3849069-230-2"
                    class="ad_300_250"
                    story={story}
                  />
                </aside>
              </div>
              <div className={styles["gurupeyarchi-ad"]}>
                <VikatanSticky placement="bundle" story={story} />
              </div>
              <MgidUnderArticleAd />
            </div>
          </div>
        </div>
        <div />
      </div>
    );
  }
}

const tamilMonthMap = {
  1: "ஜனவரி",
  2: "பிப்ரவரி",
  3: "மார்ச்",
  4: "ஏப்ரல்",
  5: "மே",
  6: "ஜூன்",
  7: "ஜூலை",
  8: "ஆகஸ்ட்",
  9: "செப்டம்பர்",
  10: "அக்டோபர்",
  11: "நவம்பர்",
  12: "டிசம்பர்"
};

const tamilWeekMap = {
  0: "ஞாயிறு",
  1: "திங்கள்",
  2: "செவ்வாய்",
  3: "புதன்",
  4: "வியாழன்",
  5: "வெள்ளி",
  6: "சனி"
};

const getDateInTamil = timeInMillis => {
  if (!timeInMillis) {
    return null;
  }
  const dateObj = new Date(timeInMillis);
  const dateUTC = new Date(dateObj.getTime() + dateObj.getTimezoneOffset() * 60 * 1000);
  const dateIST = new Date(dateUTC.getTime() + 19800000);

  return {
    date: dateIST.getDate(),
    month: tamilMonthMap[dateIST.getMonth() + 1],
    year: dateIST.getFullYear(),
    week: tamilWeekMap[dateIST.getDay()]
  };
};

const SideBar = ({ zodiacs, rasipalanSlug, selectedZodiac, className, config }) => {
  const domainName = get(config, ["sketches-host"]);

  const signs = zodiacs.map(zodiac => (
    <Link
      href={`${domainName}/horoscope/${rasipalanSlug}/${zodiac.en_name}`}
      key={zodiac.type}
      className={`${styles["sidebar__zodiac"]}`}
    >
      <ZodiacIcon
        type={zodiac.type}
        className={styles["sidebar__zodiac-icon"]}
        hoverDefault={selectedZodiac === zodiac.type}
      />
      <h3 className={styles["sidebar__zodiac-name"]}>{zodiac.display_name}</h3>
    </Link>
  ));
  return <div className={`${className} ${styles["sidebar__base"]}`}>{signs}</div>;
};

const ZodiacCard = ({ card, className, story, config }) => {
  let elements = card["story-elements"].map(element => <StoryElement card={card} element={element} key={element.id} />);
  const authors = get(story, ["authors"], {});
  const contributors = get(story, ["contributors"], {});
  const tags = get(story, ["tags"], {});

  return (
    <section className={className}>
      {elements}
      <br />
      <b>Author:</b>
      <AuthorDetail authors={authors} config={config} contributors={contributors} className={styles["author-detail"]} />
      <br />
      <b>Tags:</b>
      <Tags tags={tags} className={styles.tags} />
    </section>
  );
};

ZodiacCard.propTypes = {
  card: PropTypes.any,
  className: PropTypes.string,
  story: PropTypes.shape(),
  config: PropTypes.shape()
};

SideBar.propTypes = {
  zodiacs: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      display_name: PropTypes.string,
      dates: PropTypes.string
    })
  ),
  selectedZodiac: PropTypes.string,
  rasipalanSlug: PropTypes.string,
  className: PropTypes.string,
  config: PropTypes.shape()
};

RasipalanLandingPage.propTypes = {
  data: PropTypes.shape({
    story: PropTypes.any,
    zodiacs: SideBar.propTypes.zodiacs
  }),
  config: PropTypes.shape({
    contentInsightsId: PropTypes.string
  }),
  stickyShare: PropTypes.bool,
  rasipalanShare: PropTypes.bool
};

export default RasipalanLandingPage;
